import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="questions--designed-in-quebec--question3"
export default class extends Controller {
  static targets = ["pathYes", "pathNo", "radio"];

  connect() {
    this.toggled = false
    this.radioTargets.filter((t) => t.checked === true).forEach((target) => {
      this.showForm(undefined, target.value)
    })
  }

  showForm(e, radioValue) {
    if (this.toggled) {
      this.pathYesTarget.classList.toggle("d-none")
      this.pathNoTarget.classList.toggle("d-none")
    } else {
      let radioSelected = e === undefined ? radioValue : e.target.value // can be called from the controller
      let target = radioSelected === "false" ? this.pathNoTarget : this.pathYesTarget
      target.classList.remove("d-none")
    }
    this.toggled = true
  }
}
